module.exports = __webpack_public_path__ + "static/media/lightful_logo_purple.4888adad.svg";